import React from 'react'

type AnimationButtonProps = {
  children: React.ReactNode
  className?: string
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  onFocus?: () => void
  onBlur?: () => void
  style?: React.CSSProperties
}

const AnimationButton = ({
  children,
  className = '',
  onClick,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  style,
}: AnimationButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      style={style}
      className={`bg-[#0b0636] text-white w-full rounded-full px-3 py-2 md:px-5 md:py-2 lg:px-10 lg:py-5 text-xl md:text-2xl text-center flex items-center justify-center cursor-pointer ${className}`}
    >
      {children}
    </button>
  )
}

export default AnimationButton
